import { Component, OnInit, Input } from '@angular/core';
import { CpMarketplaceApiService } from '../../../services/cp-marketplace-api.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { LOGIN_MESSAGES } from 'src/app/messages';
import { loginParamsData } from 'appRootPath/interfaces/cp.models';
import { EncryptionService } from 'appRootPath/services/cp-encryption.service';

class SetPasswordDetails {
  username: string;
  password: string;
  confirmPassword: string;
}

@Component({
  selector: 'app-set-password-component',
  templateUrl: './set-password.component.html',
  styles: []
})

/**
 * Set Password Form Component. This component is shown when user clicks on the link in the email when they triggered
 * Forgot Password flow.
 */
export class SetPasswordFormComponent implements OnInit {
  setPasswordDetails = new SetPasswordDetails();
  @Input() loginParams: loginParamsData;
  publicKey;

  constructor(
    private apiService: CpMarketplaceApiService,
    private encryptionService: EncryptionService,
    private toastr: ToastrService,
    private router: Router
  ) {

  }

  ngOnInit() {
    this.setPasswordDetails.username = this.loginParams.username;
    this.getPublicKey();
  }

  /**
   * Gets the public key from the backend. Uses the retreived public key to encrypt the passwords.
   */
  getPublicKey(): void {
    this.apiService.getPublicKey().subscribe((resp: any) => {
      if(resp) {
        this.publicKey = this.encryptionService.getPublicKey(resp.credentials_public_key);
      }
    });
  }

  setPassword(): void {
    if (this.setPasswordDetails.password && this.setPasswordDetails.confirmPassword) {
      const apiParams = {
        new_password1: this.encryptionService.getCipherText(this.setPasswordDetails.password, this.publicKey),
        new_password2: this.encryptionService.getCipherText(this.setPasswordDetails.confirmPassword, this.publicKey),
        token: this.loginParams.token,
        uidb64: this.loginParams.uuid
      };
      this.apiService.setPassword(apiParams).subscribe((resp: any) => {
        if (resp.password_status === 'SET') {
          this.toastr.success(resp.message);
          window.setTimeout(() => {
            this.toastr.success(LOGIN_MESSAGES.RESET_PASSWORD_SUCCESS);
          }, 200);
          window.setTimeout(() => {
            this.router.navigate(['/login']);
          }, 800);
        } else if (resp.password_status === 'NOT_SET') {
          // API Error
          this.toastr.warning(resp.message);
        }
      });
    }
  }

}
